import { useState } from 'react'
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core'
import { func, string } from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'

const SelectResponseItem = (props) => {
  const styles = makeStyles((theme) => ({
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
  }))
  const { responseFromParent, callbackFromParentResponse } = props

  const [selectedResponse, setSelectedResponse] = useState(
    responseFromParent || '', // Default to '' if responseFromParent is undefined
  )

  const classes = styles(props)

  const handleChange = (event) => {
    setSelectedResponse(event.target.value)
    callbackFromParentResponse(event.target.value)
  }

  return (
    <div>
      <FormControl className={classes.formControl}>
        <InputLabel id="response-label">Response</InputLabel>
        <Select
          labelId="response-label"
          value={selectedResponse}
          onChange={handleChange}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="Negative">Negative</MenuItem>
          <MenuItem value="Positive">Positive</MenuItem>
        </Select>
      </FormControl>
    </div>
  )
}

export default SelectResponseItem

SelectResponseItem.propTypes = {
  responseFromParent: string,
  callbackFromParentResponse: func.isRequired,
}
